import React, { useState } from 'react';
import { Box, Button, Menu, MenuItem, Typography } from '@mui/material';
import Flag from 'react-world-flags';
import { useLanguage } from '../contexts/LanguageContext';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const languages = [
  { code: 'en', name: 'English', flag: 'GB' },
  { code: 'sr', name: 'Srpski', flag: 'RS' },
  { code: 'no', name: 'Norsk', flag: 'NO' },
  { code: 'es', name: 'Español', flag: 'ES' },
  { code: 'de', name: 'Deutsch', flag: 'DE' },
  { code: 'id', name: 'Bahasa Indonesia', flag: 'ID' }
  
];

function LanguageSelector() {
  const { language, changeLanguage } = useLanguage();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageSelect = (langCode) => {
    changeLanguage(langCode);
    handleClose();
  };

  const currentLang = languages.find(lang => lang.code === language);

  return (
    <Box sx={{
      width: 140,
      display: 'flex',
      justifyContent: 'center'
    }}>
      <Button
        id="language-button"
        aria-controls={open ? 'language-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
        sx={{ 
          width: '100%',
          bgcolor: 'background.paper',
          boxShadow: 1,
          '&:hover': { bgcolor: 'background.paper' },
          px: 2,
          minWidth: 120,
          justifyContent: 'space-between',
          color: 'text.primary'
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Flag 
            code={currentLang?.flag} 
            height="12"  // Standardized smaller size
            style={{ 
              width: '18px',  // Fixed width for all flags
              objectFit: 'contain'
            }} 
          />
          {currentLang?.name}
        </Box>
      </Button>
      <Menu
        id="language-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        MenuListProps={{
          'aria-labelledby': 'language-button',
        }}
        PaperProps={{
          sx: { minWidth: 120 }  // Match button width
        }}
      >
        {languages.map((lang) => (
          <MenuItem 
            key={lang.code} 
            onClick={() => handleLanguageSelect(lang.code)}
            selected={language === lang.code}
          >
            <Flag 
              code={lang.flag} 
              height="12"  // Match the button flag size
              style={{ 
                marginRight: 8,
                width: '18px',
                objectFit: 'contain'
              }} 
            />
            <Typography color="text.primary">{lang.name}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
}

export default LanguageSelector;
